module.exports = "/images/vendor/flag-icon-css/flags/4x3/fm.svg?59c5190c55c637cc6786bcab140eb22c";